import React from "react"
import { BankElement, ConnectExpressElement, IndividualElement, TaxElement, EntityElement, BrandElement, TerminalElement } from "@tap-payments/auth-jsconnect"
import { useSearchParams } from "react-router-dom"
import { SettingAsyncData } from "./types"
import { getDeploymentRegion } from "./utils"

type ConnectExpressProps = {
  configToken?: string
  settingData?: SettingAsyncData
}
export default function ConnectExpress({ configToken, settingData }: ConnectExpressProps) {
  const [token, setToken] = React.useState("")
  const [name, setName] = React.useState<"express" | "brand" | "tax" | "bank" | "individual" | "entity" | "terminal">("express")
  const [searchParams] = useSearchParams()
  const leadId = searchParams.get("leadId")
  const showBoard = searchParams.get("showBoard")
  const boardMaturity = !(searchParams.get("boardMaturity") === "false")

  const countryCode = searchParams.get("country_code")
  const [busCountryCode, setBusCountryCode] = React.useState(countryCode ?? "")
  const region = getDeploymentRegion()

  const onBoardButtonClick = (item: any) => {
    setToken(item.token)
    setName(item.name)
    if (item.countryCode) setBusCountryCode(item.countryCode)
  }

  if (name === "brand") {
    return (
      <BrandElement
        open={true}
        configToken={configToken}
        scope='merchant'
        merchantDomain={window.location.origin}
        publicKey={"pk_test_lat64TEDSvHrUOYAxVRe28PQ"}
        appInfo={{
          name: "Tap Connect Demo"
        }}
        language={"en" as any}
        onError={(error: any) => {
          console.log(JSON.stringify({ error }))
        }}
        onFlowCompleted={(res: any) => console.log("onFlowCompleted", res)}
        verifyToken={token}
        businessCountryCode={busCountryCode ?? ""}
        onBoardButtonClick={onBoardButtonClick}
        region={region}
      />
    )
  }
  if (name === "tax") {
    return (
      <TaxElement
        open={true}
        configToken={configToken}
        scope='merchant'
        merchantDomain={window.location.origin}
        publicKey={"pk_test_lat64TEDSvHrUOYAxVRe28PQ"}
        appInfo={{
          name: "Tap Connect Demo"
        }}
        businessCountryCode={busCountryCode ?? ""}
        language={"en" as any}
        onError={(error: any) => {
          console.log(JSON.stringify({ error }))
        }}
        onFlowCompleted={(res: any) => console.log("onFlowCompleted", res)}
        verifyToken={token}
        onBoardButtonClick={onBoardButtonClick}
        region={region}
      />
    )
  }
  if (name === "bank") {
    return (
      <BankElement
        open={true}
        configToken={configToken}
        scope='merchant'
        merchantDomain={window.location.origin}
        publicKey={"pk_test_lat64TEDSvHrUOYAxVRe28PQ"}
        appInfo={{
          name: "Tap Connect Demo"
        }}
        businessCountryCode={busCountryCode ?? ""}
        language={"en" as any}
        onError={(error: any) => {
          console.log(JSON.stringify({ error }))
        }}
        onFlowCompleted={(res: any) => console.log("onFlowCompleted", res)}
        verifyToken={token}
        onBoardButtonClick={onBoardButtonClick}
        region={region}
      />
    )
  }
  if (name === "individual") {
    return (
      <IndividualElement
        open={true}
        configToken={configToken}
        scope='merchant'
        merchantDomain={window.location.origin}
        publicKey={"pk_test_lat64TEDSvHrUOYAxVRe28PQ"}
        appInfo={{
          name: "Tap Connect Demo"
        }}
        businessCountryCode={busCountryCode ?? ""}
        language={"en" as any}
        onError={(error: any) => {
          console.log(JSON.stringify({ error }))
        }}
        onFlowCompleted={(res: any) => console.log("onFlowCompleted", res)}
        verifyToken={token}
        onBoardButtonClick={onBoardButtonClick}
        region={region}
      />
    )
  }
  if (name === "entity") {
    return (
      <EntityElement
        open={true}
        configToken={configToken}
        scope='merchant'
        merchantDomain={window.location.origin}
        publicKey={"pk_test_lat64TEDSvHrUOYAxVRe28PQ"}
        appInfo={{
          name: "Tap Connect Demo"
        }}
        businessCountryCode={busCountryCode ?? ""}
        language={"en" as any}
        onError={(error: any) => {
          console.log(JSON.stringify({ error }))
        }}
        onFlowCompleted={(res: any) => console.log("onFlowCompleted", res)}
        verifyToken={token}
        onBoardButtonClick={onBoardButtonClick}
        region={region}
      />
    )
  }


	if (name === 'terminal') {
		return (
			<TerminalElement
        open={true}
        configToken={configToken}
        scope='merchant'
        merchantDomain={window.location.origin}
        publicKey={"pk_test_lat64TEDSvHrUOYAxVRe28PQ"}
        appInfo={{
          name: "Tap Connect Demo"
        }}
        businessCountryCode={""}
        language={"en" as any}
        onError={(error: any) => {
          console.log(JSON.stringify({ error }))
        }}
        onFlowCompleted={(res: any) => console.log("onFlowCompleted", res)}
        verifyToken={token}
        onBoardButtonClick={onBoardButtonClick}
        region={region}
			/>
		)
	}

  return (
    <ConnectExpressElement
      open={true}
      configToken={configToken}
      settingData={settingData}
      merchantDomain={window.location.origin}
      publicKey={"pk_test_lat64TEDSvHrUOYAxVRe28PQ"}
      leadId={leadId || ""}
      showBoard={showBoard ? showBoard === "true" : true}
      boardMaturity={boardMaturity}
      onBoardButtonClick={onBoardButtonClick}
      appInfo={{
        identifier: "tap_connect_demo",
        name: "Tap Connect Demo",
        version: "V2.0.0"
      }}
      businessCountryCode={busCountryCode ?? ""}
      language={"en" as any}
      scope='merchant'
      region={region}
      onError={(error) => {
        console.log(JSON.stringify({ error }))
      }}
      onFlowCompleted={(data) => {
        console.log(data, "Flow Completed")
      }}
      onReady={() => {
        console.log("ready!")
      }}
      onStepCompleted={(name, data) => {
        console.log(name, data, "step completed")
      }}
      onStepStarted={(name) => {
        console.log(name, "Step Started")
      }}
      onClose={() => {
        console.log("close")
      }}
      onCreated={(data) => {
        console.log(data, "onCreated")
      }}
    />
  )
}
